module.exports = "./src/client/components/document/detail/document-type/image/document-type-space.png?265bc8ddc667f2b3ab993800154cd75c";